import { defineMessages } from 'react-intl';

export default defineMessages({
  yes: 'Yae',
  no: 'Nay',
});
